import { render, staticRenderFns } from "./FullImageSection.vue?vue&type=template&id=4e652eac&scoped=true"
import script from "./FullImageSection.vue?vue&type=script&lang=js"
export * from "./FullImageSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e652eac",
  null
  
)

export default component.exports